import './PopoverModal.scss';

import classNames from 'classnames';
import { getClosestButton } from '@lib/popups';

import React, { useEffect, useState } from 'react';
import { SonarModal, SonarModalProps } from './SonarModal';

export type PopoverPosition = 'bottomLeft' | 'bottomRight' | 'topLeft' | 'topRight';

export interface PopoverModalProps extends SonarModalProps {
	popoverTarget: React.RefObject<HTMLElement>;
	popoverPosition?: PopoverPosition;
}

function calculatePopoverPosition(position: PopoverPosition, triggerButton: HTMLElement): React.CSSProperties {
	const { bottom, left, right, top } = triggerButton.getBoundingClientRect();

	if (position === 'bottomLeft') {
		return {
			left,
			top: bottom + 3
		};
	}

	if (position === 'bottomRight') {
		return {
			right: window.innerWidth - right,
			top: bottom + 3
		};
	}

	if (position === 'topLeft') {
		return {
			bottom: top - 3,
			left
		};
	}

	if (position === 'topRight') {
		return {
			bottom: top - 3,
			right: window.innerWidth - right
		};
	}

	return {};
}

export const PopoverModal: React.FC<PopoverModalProps> = ({
	className,
	open,
	popoverTarget,
	popoverPosition = 'bottomLeft',
	style,
	...rest
}) => {
	const [ customStyle, setCustomStyle ] = useState<React.CSSProperties>(style ?? {});

	useEffect(() => {
		const target = popoverTarget.current;

		if (open && target) {
			setCustomStyle((current) => ({
				...current,
				...calculatePopoverPosition(popoverPosition, getClosestButton(target) ?? target)
			}));
		}
	}, [ open, popoverPosition, popoverTarget ]);

	const modalClassNames = classNames(
		'sonar-modal-popover',
		{
			'sonar-modal-popover-bottom-left': popoverPosition === 'bottomLeft',
			'sonar-modal-popover-bottom-right': popoverPosition === 'bottomRight',
			'sonar-modal-popover-top-left': popoverPosition === 'topLeft',
			'sonar-modal-popover-top-right': popoverPosition === 'topRight'
		},
		'flex-inputs',
		className
	);

	return <SonarModal
		{ ...rest }
		className={ modalClassNames }
		open={ open }
		style={ customStyle } />;
};
